<template>
  <div class="main-ct">
    <div class="description-ct">
      <p class="header-paragraph">
        {{ $t('Gamification_Drive_Relevant_Players_Pay_To_Play_Activities') }}
      </p>
      <p class="description-paragraph">
        {{ $t('Gamification_Drive_Relevant_Players_Use_Distribute_Rewards') }}
      </p>
    </div>
    <div>
      <img
        src="@/img/gamification/xp-tb-drive-relevant-players.png"
        :alt="$t('Gamification_Drive_Relevant_Players_Pay_To_Play_Activities')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationDriveRelevantPlayers'
}
</script>

<style scoped>
.main-ct {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 60px 65px;
}

.description-ct {
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.header-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  text-wrap: balance;
}

.description-paragraph {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

img {
  width: 460px;
  height: 325px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationDriveRelevantPlayers.vue